import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { IPC_CHANNEL } from "../../_offline/electron.constants";
import { TenantDetailSchema } from "../../_offline/models/tenant-detail.schema";
import { DatabaseBaseService } from "../base/database-base.service";
import { LoginUserOfflineService } from "../offline/login-user-offline.service";
import { ElectronService } from "../../electron.service";

@Injectable({
  providedIn: "root"
})
export class TenantDetailDbService extends DatabaseBaseService {
  constructor(
    protected electronService: ElectronService,
    protected loginUserService: LoginUserOfflineService
  ) {
    super(electronService, loginUserService);
  }

  get(): Observable<TenantDetailSchema> {
    return this.ipcSendSync(IPC_CHANNEL.TENANT_DETAIL.GET_ONE, this.tenantId);
  }

  put(tenantDetail: TenantDetailSchema): Observable<TenantDetailSchema> {
    return this.ipcSendSync(IPC_CHANNEL.TENANT_DETAIL.PUT_ONE, tenantDetail);
  }
}
